import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { Icon } from 'gu-ui-kit'
import styles from 'components/Nav/nav.module.scss'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'

const SecurityLink = ({ className, activeClassName, exact, to, children }) => {
  const {
    initialized = false,
    enabled = false,
    is_2fa_available = false,
  } = useSelector((state) => ({
    ...state['user/2fa'],
    ...state['user/profile'],
  }))
  const dispatch = useDispatch()

  useEffect(() => {
    if (initialized) {
      return
    }
    dispatch({ type: 'USER/GET_2FA' })
  }, [initialized])

  return (
    <NavLink
      className={className}
      activeClassName={activeClassName}
      exact={exact}
      to={to}
    >
      {children}
      {is_2fa_available && initialized && !enabled && (
        <span
          className={clsx(
            styles['nav__notification'],
            styles['nav__notification_warning'],
          )}
        >
          <Icon name={'status warning'} size={'m'} />
        </span>
      )}
    </NavLink>
  )
}
export default SecurityLink

SecurityLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
